import List from './index'

import Taxes from "../../Fiscal/Taxes"
import ICMS from "../../Fiscal/Taxes/ICMS"
import IPI from "../../Fiscal/Taxes/IPI"
import PIS from "../../Fiscal/Taxes/PIS"
import COFINS from "../../Fiscal/Taxes/COFINS"
import IBSCBS from "../../Fiscal/Taxes/IBSCBS"
import Product from "./Product"
import Suppliers from "./Suppliers"
import Categories from "./Categories"
import Units from "./Units"

export const paths = [
    {
        path: '/product/:id',
        component: Product
    },
    {
        path: '/products/create',
        component: Product
    },
    {
        path: '/products',
        component: List
    },

    {
        path: '/suppliers',
        component: Suppliers
    },
    {
        path: '/products/categories',
        component: Categories
    },
    {
        path: '/products/units',
        component: Units
    },
    {
        path: '/products/taxes',
        component: Taxes
    },
    {
        path: '/products/taxes/icms',
        component: ICMS
    },
    {
        path: '/products/taxes/ipi',
        component: IPI
    },
    {
        path: '/products/taxes/pis',
        component: PIS
    },
    {
        path: '/products/taxes/cofins',
        component: COFINS
    },
    {
        path: '/taxes/ibs-cbs',
        component: IBSCBS
    }
]

export const ProductsRouters = {
    icon: "box-open",
    testId: '',
    path: "/products",
    label: "Produtos",
    tree: [
        {
            testId: '',
            icon: 'plus',
            path: '/products/create',
            label: "Cadastrar",
        },
        {
            testId: '',
            icon: 'box-open',
            path: '/products',
            label: "Listar",
            component: List
        },
        {
            testId: 'menu-products-categories',
            icon: 'tags',
            path: '/products/categories',
            label: 'Categorias',
            component: Categories
        },
        {
            testId: 'menu-products-units',
            icon: 'ruler',
            path: '/products/units',
            label: 'Unidades',
            component: Units
        },
        {
            testId: '',
            icon: 'balance-scale',
            path: '/taxes/icms',
            label: "ICMS",
            component: ICMS
        },
        {
            testId: '',
            icon: 'balance-scale',
            path: '/taxes/ipi',
            label: "IPI",
            component: IPI
        },
        {
            testId: '',
            icon: 'balance-scale',
            path: '/taxes/pis',
            label: "PIS",
            component: PIS
        },
        {
            testId: '',
            icon: 'balance-scale',
            path: '/taxes/cofins',
            label: "COFINS",
            component: COFINS
        },
        {
            testId: '',
            icon: 'balance-scale',
            path: '/taxes/ibs-cbs',
            label: "IBS/CBS",
            component: IBSCBS
        },
        {
            testId: '',
            icon: 'users',
            path: '/suppliers',
            label: "Fornecedores",
            component: List
        },
    ]
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Products/routers.js